export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PackageTracking.vue?vue&type=template&id=5167e664&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/PackageTracking.vue?vue&type=template&id=5167e664&scoped=true
// module id = 2088
// module chunks = 31